import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router/src/utils/preactivation';
import { RouterStateSnapshot, Router } from '@angular/router';

@Injectable()
export class AuthGurdService implements CanActivate {
  path: import("@angular/router").ActivatedRouteSnapshot[];
  route: import("@angular/router").ActivatedRouteSnapshot;

  constructor(private router: Router) { }

  canActivate(next: import("@angular/router").ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const allowedRoles = next.data.allowedRoles;
    if (allowedRoles) {
      if (this.isLoggedIn() && allowedRoles.indexOf(JSON.parse(localStorage.getItem('userInfo')).role) != -1 ) {
        return true;
      } else {
        this.router.navigateByUrl('/');
        return false;
      }
    } else {
      this.router.navigateByUrl('/');
      return false;
    }
  }


  isLoggedIn() {
    const userAuth = localStorage.getItem('token');
    if (!userAuth) {
      return false;
    } else {
      return true;
    }
  }
}
